exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-editar[data-v-90d067ca] {\n  background-color: rgb(255, 108, 0) !important;\n  border-color: rgb(255, 108, 0) !important;\n  padding-right: 20px;\n  display: block;\n  margin: 0 0 0 auto;\n  height: 37px;\n}\n", ""]);

// exports
